export default __webpack_public_path__ + "static/media/swim.3d05d0c0.jpg";